import axiosClient from '@app/services/axios';
import {
    PHIEUTHUTIEN_METHOD,
    MAU_METHOD
} from '@app/const/AppSetting';
import {getSaveResult} from '@app/utils/helpers';
import axiosClientExcel from "@app/services/axiosExcel";

const  MY_METHOD = PHIEUTHUTIEN_METHOD;

export const myService = {
    // eslint-disable-next-line no-use-before-define
    
    getAll,
    getById,
    Create,
    Update,
    Delete,
    excel,excelPath
};

function excelPath(params) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}excelPath`, params));
}

function getAll(CurrentPage, PageSize, paramFilter) {
    const v = axiosClient
        .post(
            `${MY_METHOD}search/${CurrentPage}/${PageSize}`,
            paramFilter
        )
        .then((responde) => {
            return responde.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}


function getById(id) {
    return axiosClient.get(`${MY_METHOD}${id}`);
}

function Create(params) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}`, params));
}
function Delete(id) {
    return getSaveResult(axiosClient.delete(`${MY_METHOD}${id}`));

}

function Update(id, params) {
    return getSaveResult(axiosClient.put(`${MY_METHOD}${id}`, params));
}


function excel(CurrentPage, PageSize, paramFilter) {
    return axiosClientExcel.post(`${MY_METHOD}excel/${CurrentPage}/${PageSize}`,
            paramFilter);
    
}
